import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Result } from '@team23/ts-result';
import { IconStatus } from '@ui/shared/util-api';

@Injectable({ providedIn: 'root' })
export abstract class AbstractSvgIconService {

    /**
     * Fetch or create an svg icon based on the given iconPath.
     *
     * @param iconPath the relative path of the icon on the server.
     * @returns an svg icon, wrapped in a {@link Result}.
     */
    public abstract getIconSvgByPath$(iconPath: string): Observable<Result<string, IconStatus>>;
}
